import axios from '../core/axios';

import { ApiConstants } from './api-constants';

export class ProfileService {
  static uploadFile = async (data: any, contentType: string) => {
    return await (
      await axios.post(
        ApiConstants.PROFILE_API.UPLOAD_PROFILE_IMAGE.URL(),
        { ...data },
        {
          headers: {
            'Content-Type': 'multipart/form-data', // Important to set this header
          },
        },
      )
    ).data;
  };
}
